import React, { useEffect } from 'react'
import ServicesSection from '../../components/common/ServicesSection'
import PageTitle from '../../components/common/PageTitle'
import ServicesCard from '../../components/cards/ServicesCard'
import WhyUsSection from '../../components/common/WhyUsSection'
import { useDispatch, useSelector } from 'react-redux'
import { getServices } from '../../services/actions/MainAction'

function Services() {
  const contentData = useSelector(state => state.Data.contentData);
  const lang_id = useSelector(state => state.Data.lang_id);
  const services = useSelector(state => state.Data.services);
  const dispatch = useDispatch()
   useEffect(()=>{
      window.scrollTo(0,0);
      dispatch(getServices(lang_id))
    },[lang_id]);
  return (
    <main className='mt-[0px] min-h-[80vh]'>
      <PageTitle title={contentData?.nav_2}/>
      <div className='container2'>
        <div className='grid grid-cols-4 gap-[40px]  relative mt-[30px] max-[1200px]:grid-cols-3 gap-y-[20px] max-[800px]:grid-cols-2 max-[500px]:grid-cols-1 gap-y-[0px]'>
          {
            services?.map((data, i) => {
              return (
                 <ServicesCard 
                  key={i}
                  data={data}
                 />
              )
            })
          }
        </div>
      </div>
      <WhyUsSection />
    </main>
  )
}

export default Services
